import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Rate, Input, Button, Typography, message } from "antd";
import reviewService from "../services/reviewService";

import "./AddReview.css";

const { Title } = Typography;
const { TextArea } = Input;

const AddReview = () => {
  const { bookingId } = useParams();
  const navigate = useNavigate();

  const [ratings, setRatings] = useState({
    Cleanliness: 0,
    Communication: 0,
    Service: 0,
    Value: 0,
  });
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);

  const handleRatingChange = (category, value) => {
    setRatings((prevRatings) => ({
      ...prevRatings,
      [category]: value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const ratingValues = Object.entries(ratings).map(([type, value]) => ({
        type,
        value,
      }));

      await reviewService.submitReview(bookingId, ratingValues, comment);

      message.success("Review submitted successfully!");
      navigate("/travelerhome");
    } catch (error) {
      console.error("Failed to submit review:", error);
      message.error(
        error.response?.data?.message ||
        "Failed to submit review. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="review-page-container">
      <h2 className="review-title">Add Review</h2>

      {Object.keys(ratings).map((category) => (
        <div key={category} className="rating-group">
          <h4 className="rating-label">{category}</h4>
          <Rate
            value={ratings[category]}
            onChange={(value) => handleRatingChange(category, value)}
          />
        </div>
      ))}

      <div className="review-textarea-group">
        <label className="review-textarea-label">Your Review</label>
        <TextArea
          rows={6}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Share your experience..."
          maxLength={5000}
        />
      </div>

      <Button
        type="primary"
        size="large"
        block
        onClick={handleSubmit}
        loading={loading}
        className="submit-review-btn"
      >
        Submit Review
      </Button>
    </div>
  );
};

export default AddReview;
